import axios from 'axios';

/**
 * Detects if the user's IP is from China or USA (temporarily for testing)
 * @returns {Promise<boolean>} True if the user's IP is from China or USA, false otherwise
 */
export const isChineseIP = async () => {
  try {
    // Use ipapi.co which is a free IP geolocation API
    const response = await axios.get('https://ipapi.co/json/');
    
    // Check if the country code is CN (China)
    const countryCode = response.data.country_code;
    const isChinese = countryCode === 'CN';
    
    if (isChinese) {
      console.log(`IP detected from ${countryCode}, setting language to Chinese`);
    }
    
    return isChinese;
  } catch (error) {
    console.error('Error detecting IP location:', error);
    return false;
  }
};

/**
 * Language detector plugin for i18next that detects Chinese IPs
 */
export const chineseIPDetector = {
  type: 'languageDetector',
  name: 'chineseIPDetector',
  
  init(services, detectorOptions, i18nextOptions) {
    this.services = services;
    this.options = { ...detectorOptions, ...i18nextOptions };
  },
  
  detect() {
    // Check if we already have a cached result
    const cachedLang = localStorage.getItem('i18nextLngIP');
    if (cachedLang) {
      return cachedLang;
    }
    
    // Start the async detection process
    this.detectAsync().then(lang => {
      if (lang) {
        this.cacheUserLanguage(lang);
        // If language was detected, change it
        if (this.services && this.services.i18next) {
          this.services.i18next.changeLanguage(lang);
        }
      }
    });
    
    // Return null initially, the async process will update the language if needed
    return null;
  },
  
  async detectAsync() {
    try {
      const isFromChina = await isChineseIP();
      
      if (isFromChina) {
        return 'cn';
      }
      
      return null;
    } catch (error) {
      console.error('Error in Chinese IP detection:', error);
      return null;
    }
  },
  
  cacheUserLanguage(lng) {
    // Cache the language in localStorage
    localStorage.setItem('i18nextLngIP', lng);
  }
};
